"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashAddress = void 0;
const utils_1 = require("ethers/lib/utils");
function hashAddress(address) {
    return (0, utils_1.namehash)(address.toLowerCase().substring(2) + '.addr.reverse');
}
exports.hashAddress = hashAddress;
